import { AxiosResponse } from "axios";
import { getAxiosInstance } from "./api-utils";
import { User } from "@/model/user";

const GLOBAL_USERS = "/global/users";

export async function getUsers(): Promise<User[]> {
    const response: AxiosResponse<User[]> = await getAxiosInstance().get(GLOBAL_USERS);
    return response.data;
}

export async function getUser(id: number): Promise<User> {
    const response: AxiosResponse<User> = await getAxiosInstance().get(`${GLOBAL_USERS}/${id}`);
    return response.data;
}

export async function saveUser(model: { object: User, initialObject: User }) {
    const response = await getAxiosInstance().patch(`${GLOBAL_USERS}/${model.object.id}`, model.object);
    return response.data;
}

export async function createUser(user: User) {
    const response: AxiosResponse<User> = await getAxiosInstance().put(GLOBAL_USERS, user);
    return response.data.id;
}

export async function addUserInstance(userId: number, instanceId: number) {
    const response = await getAxiosInstance().post(`${GLOBAL_USERS}/${userId}/instances/${instanceId}`);
    return response.data;
}

export async function removeUserInstance(userId: number, instanceId: number) {
    await getAxiosInstance().delete(`${GLOBAL_USERS}/${userId}/instances/${instanceId}`);
}

export async function getAllInstances() {
    const response = await getAxiosInstance().get("/global/instances");
    return response.data;
}
